import { useCallback } from "react";
import { Pill } from "@mantine/core";

interface UnavailablePrefixChipProps {
  prefixKey: string;
  onRemove: (prefixKey: string) => void;
}

export default function UnavailablePrefixChip({
  prefixKey,
  onRemove,
}: UnavailablePrefixChipProps) {
  const handleRemove = useCallback(
    () => onRemove(prefixKey),
    [onRemove, prefixKey]
  );
  const label =
    prefixKey === "__OTHER__" ? "Other / nonstandard number" : prefixKey;

  return (
    <Pill
      withRemoveButton
      onRemove={handleRemove}
      removeButtonProps={{ "aria-label": `Remove unavailable prefix ${label}` }}
    >
      {label} (unavailable)
    </Pill>
  );
}
